import { Inject, Injectable } from '@angular/core';
import {
  AlertActions,
  AlertQueries,
  AUTH_SERVICE_TOKEN,
  AuthServiceInterface,
  CredentialActions,
  CredentialQueries,
  DalState,
  DataActions,
  FavoriteActions,
  FavoriteQueries,
  HistoryQueries,
  LearningAreaQueries,
  MethodQueries,
  NewsCategoryNewsQueries,
  NewsCategoryQueries,
  NewsQueries,
  PersonPreferenceQueries,
  RoleQueries,
  SchoolQueries,
  SchoolRoleMappingQueries,
  StateResolver,
  TaskEduContentQueries,
  TaskInstanceQueries,
  TaskQueries,
  UiActions,
  UiQuery,
} from '@campus/dal';
import { Action, Selector, Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class AppResolver extends StateResolver {
  constructor(
    private store: Store<DalState>,
    @Inject(AUTH_SERVICE_TOKEN) private authService: AuthServiceInterface
  ) {
    super(store);
  }

  protected getLoadableActions(): Action[] {
    const userId = this.authService.userId;

    return [
      new DataActions.LoadData({
        userId,
        fields: [
          'allowedMethods',
          'learningAreas',
          'history',
          'bundles',
          'tasks',
          'taskInstances',
          'taskEduContents',
          'eduContents',
          'roles',
          'personPreferences',
          'schools',
          'schoolRoleMappings',
        ],
      }),
      new DataActions.LoadData({
        userId,
        fields: ['news', 'newsCategories', 'newsCategoryNews'],
      }),
      new CredentialActions.LoadCredentials({ userId }),
      new AlertActions.LoadAlerts({ userId }),
      new UiActions.LoadUi(),
      new FavoriteActions.LoadFavorites({ userId }),
    ];
  }
  protected getResolvedQueries(): Selector<object, boolean>[] {
    return [
      CredentialQueries.getLoaded,
      AlertQueries.getLoaded,
      LearningAreaQueries.getLoaded,
      MethodQueries.getAllowedMethodsLoaded,
      FavoriteQueries.getLoaded,
      HistoryQueries.getLoaded,
      UiQuery.getLoaded,
      TaskQueries.getLoaded,
      TaskInstanceQueries.getLoaded,
      TaskEduContentQueries.getLoaded,
      RoleQueries.getLoaded,
      PersonPreferenceQueries.getLoaded,
      SchoolQueries.getLoaded,
      SchoolRoleMappingQueries.getLoaded,
      NewsQueries.getLoaded,
      NewsCategoryQueries.getLoaded,
      NewsCategoryNewsQueries.getLoaded,
    ];
  }
}
